export default "__VITE_ASSET__HuDQKQmZ__"